const late_for_party = `Hei, olen todella pahoillani, mutta pääsen syntymäpäiväjuhlillesi vasta noin kahdeksalta.
Minulla on tärkeä perhesitoumus, jota en voi jättää väliin, mutta teen parhaani päästäkseni siihen mahdollisimman pian.
Pyydän anteeksi myöhästymistäni ja odotan todella innolla, että pääsen juhlimaan kanssasi.
Nähdään kahdeksalta!`;

export default late_for_party;